module.exports = __webpack_public_path__ + "img/InfoSoft.b2d33053.png";